import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ImageModule } from 'primeng/image';
import { TooltipModule } from 'primeng/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { LEGAL_LINKS } from 'src/app/shared/constants';

@Component({
  selector: 'new-app-footer',
  standalone: true,
  imports: [ImageModule, TooltipModule, TranslatePipe],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {

  protected readonly logoImg = '../../../assets/pictures/redesign-logo.svg';

  // Externe Rechtstext-Links aus der geteilten Single Source of Truth. Labels werden
  // im Template via translate-Pipe aufgelöst (reagiert automatisch auf Sprachwechsel).
  protected readonly links = LEGAL_LINKS;
}
